import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=b1c02c6e"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=b1c02c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports